import * as moment from 'moment';
import * as React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import DateRangeInput from 'src/components/dateRangeInput/DateRangeInput';
import { TR } from 'src/TextRes';
import {
    ApiAccountingLoadmine,
    ApiCourseDelete,
    ApiCourseLoadmine,
    ApiCourseNew,
    ApiCourseProvidersLoadmine,
    CoursesListLoadMineLine,
    CoursesListLoadMineParams,
    CoursesProviderLoadMineResult,
    ServerResponse,
} from '../../api';
import CPCoursesTableBox from '../../components/cpCoursesTableBox/CPCoursesTableBox';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import { FieldsetWarningBox } from '../../components/fieldsetWarningBox/FieldsetWarningBox';
import Footer from '../../components/footer/Footer';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import Paging from '../../components/paging/Paging';
import { IThConfig } from '../../components/sortableTh/SortableTh';
import { IEmptyProps, ISortIcon } from '../../constants';
import './CPAllCourses.css';

interface CPAllCoursesState {
    listData: CoursesListLoadMineLine[];
    loading: boolean;
    courseDateFromSearchString: string;
    courseDateToSearchString: string;
    serverResponse?: ServerResponse;
    searchParams: CoursesListLoadMineParams;
    totalCount: number;
    sortIcon: ISortIcon[];
    profileNotCompletedWarning: boolean;
    noHistory: boolean;
    cpProfileNotCompleted: boolean;
    cpLecturerNotCompleted: boolean;
    cpLocationNotCompleted: boolean;
    cpBookingTermsNotCompleted: boolean;
    warningInvoice: boolean;
    imported: boolean;
    modalDeleteOpen: boolean;
    modalCannotDeleteOpen: boolean;
    courseIDtoDelete?: string;
}

export default class CPAllCourses extends React.PureComponent<IEmptyProps, CPAllCoursesState> {
    private renderTHeadLineArrays: IThConfig[] = [
        { sortField: 'title', name: 'Kursname', width: '50%' },
        { name: 'Dozent', width: '30%' },
        { name: 'Status', width: '12%' },
        { name: '', width: '4%' },
        { name: '', width: '4%' },
    ];

    private dpref = React.createRef<any>();

    constructor(props: IEmptyProps) {
        super(props);

        const nhstr = window.localStorage.getItem('__FDM_CPCOURSES_NOHISTORY');
        const nh = nhstr === 'false' ? false : true;

        this.state = {
            noHistory: nh,
            courseDateFromSearchString: '',
            courseDateToSearchString: '',
            cpLecturerNotCompleted: false,
            cpLocationNotCompleted: false,
            cpProfileNotCompleted: false,
            cpBookingTermsNotCompleted: false,
            listData: [],
            loading: true,
            profileNotCompletedWarning: false,
            searchParams: {
                Descending: false,
                EndDate: '',
                Offset: 0,
                PageSize: 25,
                Search: '',
                Sort: '',
                StartDate: nh ? moment(new Date()).format('YYYY-MM-DD') : '',
            },
            serverResponse: undefined,
            sortIcon: [],
            totalCount: 0,
            warningInvoice: false,
            imported: false,
            modalDeleteOpen: false,
            modalCannotDeleteOpen: false,
        };
    }

    public componentDidMount() {
        const mySortIcon = this.state.sortIcon;
        this.renderTHeadLineArrays.map(() => {
            mySortIcon.push(0);
        });

        // to know when we should showing the warning message maybe with some server Function =>
        this.setState({ sortIcon: [...mySortIcon] }, () => {
            this.searchCourses();
            this.worningValidation();
        });
    }

    public render() {
        const {
            cpProfileNotCompleted,
            cpLecturerNotCompleted,
            cpLocationNotCompleted,
            cpBookingTermsNotCompleted,
            profileNotCompletedWarning,
            imported,
        } = this.state;
        let warningBoxProfileNotCompleted;

        if (!imported) {
            warningBoxProfileNotCompleted = (
                <FieldsetWarningBox
                    legendTitel={TR.cPAllCourses_welcome}
                    td2Content={
                        <h6 style={{ textAlign: 'left' }}>
                            {TR.cPAllCourses_welcome_text1}
                            <br />
                            <br />
                            {TR.cPAllCourses_please_complete}
                            <ol style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                <br />
                                {cpProfileNotCompleted && (
                                    <li>
                                        <a href={'#/cpprofile'}>{TR.cPAllCourses_general_info}</a>
                                    </li>
                                )}
                                {cpBookingTermsNotCompleted && (
                                    <li>
                                        <a href={'#/cpprofile'}>{TR.cPAllCourses_booking_conditions}</a>
                                    </li>
                                )}
                                {cpLecturerNotCompleted && (
                                    <li>
                                        <a href={'#/cplecturers'}>{TR.cPAllCourses_lecturers}</a>
                                    </li>
                                )}
                                {cpLocationNotCompleted && (
                                    <li>
                                        <a href={'#/cplocations'}>{TR.cPAllCourses_locations}</a>
                                    </li>
                                )}
                            </ol>
                        </h6>
                    }
                    td3Content={<div />}
                    fieldsetClass="mt-3 mb-3"
                    td1Width="15%"
                    td2Width="84%"
                    td3Width="1%"
                    useLogo={true}
                />
            );
        } else {
            warningBoxProfileNotCompleted = (
                <FieldsetWarningBox
                    legendTitel={'Informationen zur Umstellung auf kukundo 2.0'}
                    td2Content={
                        <h6 style={{ textAlign: 'left' }}>
                            {TR.cPAllCourses_welcome2}
                            <br />
                            <br />
                            {TR.cPAllCourses_welcome2_text1} <br />
                            <br />
                            {TR.cPAllCourses_welcome2_text2} <br />
                            <br />
                            {TR.cPAllCourses_welcome2_text3}
                            <br />
                            <br />
                            <ol style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                <br />
                                {cpBookingTermsNotCompleted && (
                                    <li>
                                        <strong>
                                            <a href={'#/cpprofile'}>{TR.cPAllCourses_your_conditions}</a>
                                        </strong>
                                    </li>
                                )}
                                {cpProfileNotCompleted && (
                                    <li>
                                        <a href={'#/cpprofile'}>{TR.cPAllCourses_general_profile}</a>
                                    </li>
                                )}
                            </ol>
                        </h6>
                    }
                    td3Content={<div />}
                    fieldsetClass="mt-3 mb-3"
                    td1Width="15%"
                    td2Width="84%"
                    td3Width="1%"
                    useLogo={true}
                />
            );
        }
        const toDayMoment = Number.parseInt(moment().format('D').toString(), 10);
        const halfeOfMonthMoment = Math.floor(Number.parseInt(moment().endOf('month').format('D').toString(), 10) / 2);

        const warningBoxToAccouting = (
            <FieldsetWarningBox
                legendTitel={TR.cPAllCourses_confirm_bookings}
                td2Content={
                    <h6>
                        {TR.cPAllCourses_check_bookings1} {halfeOfMonthMoment}. {TR.cPAllCourses_check_bookings2}
                    </h6>
                }
                td3Content={
                    <Button
                        onClick={() => {
                            location.hash = '#/cpbookings';
                        }}
                    >
                        {TR.cPAllCourses_to_bookings}
                    </Button>
                }
                fieldsetClass="mt-3 mb-3"
                td1Width="10%"
                td2Width="65%"
                td3Width="25%"
            />
        );

        const showWarning = profileNotCompletedWarning || cpBookingTermsNotCompleted;

        return (
            <NetworkOverlay loading={this.state.loading} serverResponse={this.state.serverResponse}>
                <CPHeaderLoggedIn />
                <Modal isOpen={this.state.modalDeleteOpen}>
                    <ModalHeader>{TR.cPAllCourses_delete_course}</ModalHeader>
                    <ModalBody>{TR.cPAllCourses_are_you_sure}</ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeModalDelete}>
                            {TR.cPAllCourses_cancel}
                        </Button>
                        <Button color="primary" onClick={this.deleteCourse}>
                            {TR.cPAllCourses_really_delete}
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalCannotDeleteOpen}>
                    <ModalHeader>{TR.cPAllCourses_bookings_exist}</ModalHeader>
                    <ModalBody>{TR.cPAllCourses_cannot_delete}</ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeModalCannotDelete}>
                            {TR.cPAllCourses_ok}
                        </Button>
                    </ModalFooter>
                </Modal>
                {!this.state.loading && (
                    <Container>
                        {showWarning && (
                            <>
                                {warningBoxProfileNotCompleted}
                                {!this.state.loading && (
                                    <Row className="mt-3 mb-3">
                                        <Col md={3} className={'offset-md-9'}>
                                            {!imported && (
                                                <Button
                                                    disabled={!imported}
                                                    style={
                                                        this.state.profileNotCompletedWarning
                                                            ? { ...{ pointerEvents: 'none' } }
                                                            : undefined
                                                    }
                                                    block={true}
                                                    size="sm"
                                                    color="danger"
                                                    onClick={this.courseNew}
                                                >
                                                    <span>{TR.cPAllCourses_create_new_course}</span>
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                )}
                            </>
                        )}
                        {(imported || (!this.state.profileNotCompletedWarning && !showWarning)) && (
                            <>
                                {this.state.warningInvoice &&
                                    toDayMoment > 0 &&
                                    toDayMoment < halfeOfMonthMoment &&
                                    warningBoxToAccouting}
                                {!this.state.loading && (
                                    <>
                                        <Row className="mt-2 mb-4 courseSearchLine">
                                            <Col md="4" lg="3">
                                                <input
                                                    name="CourseNameSearching"
                                                    type="text"
                                                    placeholder="Suchen..."
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        this.changeValue('Search', e.target.value, true);
                                                    }}
                                                    style={{ padding: '2px 15px', border: '1px solid #ced4da' }}
                                                />
                                            </Col>
                                            <Col md="8" lg="5">
                                                <DateRangeInput
                                                    ref={this.dpref}
                                                    initializeToToday={this.state.noHistory}
                                                    minDate={this.state.noHistory ? moment(new Date()) : undefined}
                                                    onChangeOptionFrom={(value: string) => {
                                                        this.changeValue('StartDate', value, true);
                                                    }}
                                                    onChangeOptionTo={(value: string) => {
                                                        this.changeValue('EndDate', value, true);
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="4" className={'text-right'}>
                                                {(!showWarning || imported) && (
                                                    <Button
                                                        disabled={this.state.profileNotCompletedWarning}
                                                        style={
                                                            this.state.profileNotCompletedWarning
                                                                ? { ...{ pointerEvents: 'none' } }
                                                                : undefined
                                                        }
                                                        size="sm"
                                                        color="danger"
                                                        onClick={this.courseNew}
                                                    >
                                                        <span>{TR.cPAllCourses_create_new_course}</span>
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row className="mt-2 mb-4">
                                            <Col>
                                                {this.state.listData.length > 0 && (
                                                    <span>
                                                        <Input
                                                            type="checkbox"
                                                            checked={this.state.noHistory}
                                                            onChange={this.onToggleHistory}
                                                        />{' '}
                                                        {TR.cPAllCourses_hide_past_courses}
                                                    </span>
                                                )}
                                            </Col>
                                        </Row>

                                        {this.state.listData.length > 0 && (
                                            <Row className="mt-2">
                                                <Col>
                                                    <CPCoursesTableBox
                                                        listData={this.state.listData}
                                                        renderTHeadLine={this.renderTHeadLineArrays}
                                                        onClickSorting={this.onClickSorting}
                                                        onDelete={this.confirmDeleteCourse}
                                                        sortIcon={this.state.sortIcon}
                                                        collapsed={false}
                                                    />
                                                    <Paging
                                                        totalCount={this.state.totalCount}
                                                        pageSize={this.state.searchParams.PageSize}
                                                        offset={this.state.searchParams.Offset}
                                                        changeValue={this.changeValue}
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                        {this.state.listData.length === 0 && !this.state.searchParams.Search && (
                                            <h3>{TR.cPAllCourses_no_courses}</h3>
                                        )}
                                        {this.state.listData.length === 0 && this.state.searchParams.Search && (
                                            <h3>{TR.cPAllCourses_no_courses_for_search}</h3>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Container>
                )}
                <Footer />
            </NetworkOverlay>
        );
    }

    private deleteCourse = () => {
        this.setState({ modalDeleteOpen: false });
        if (this.state.courseIDtoDelete) {
            ApiCourseDelete({ ID: this.state.courseIDtoDelete }, (sr) => {
                if (sr.OK && sr.Data != null && !sr.Data!.HasBookings) {
                    this.setState({ loading: false, serverResponse: sr });
                } else if (sr.OK && sr.Data != null && sr.Data!.HasBookings) {
                    this.setState({ modalCannotDeleteOpen: true });
                } else {
                    this.setState({
                        loading: false,
                        serverResponse: sr,
                    });
                }
                this.searchCourses();
            });
        }
        this.setState({ courseIDtoDelete: undefined });
    };

    private closeModalDelete = () => {
        this.setState({ modalDeleteOpen: false });
    };

    private confirmDeleteCourse = (courseID: string) => {
        this.setState({ modalDeleteOpen: true, courseIDtoDelete: courseID });
    };

    private closeModalCannotDelete = () => {
        this.setState({ modalCannotDeleteOpen: false });
    };

    private changeValue = (fieldName: string, value: string | boolean | number, reload: boolean = false) => {
        const newParams = { ...this.state.searchParams };
        // @ts-ignore
        newParams[fieldName] = value;
        if (reload) {
            this.setState({ searchParams: newParams }, this.searchCourses);
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private worningValidation = () => {
        ApiCourseProvidersLoadmine((cpsr: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => {
            if (cpsr.OK && cpsr.Data) {
                const myCP = cpsr.Data.CourseProviderEdit;
                const changes: any = {
                    imported: cpsr.Data.CourseProviderData.Imported,
                };

                if (myCP.Lecturers.length < 1) {
                    changes.cpLecturerNotCompleted = true;
                    changes.profileNotCompletedWarning = true;
                } else {
                    changes.cpLecturerNotCompleted = false;
                }
                if (myCP.Locations.length < 1) {
                    changes.cpLocationNotCompleted = true;
                    changes.profileNotCompletedWarning = true;
                } else {
                    changes.cpLocationNotCompleted = false;
                }
                if (
                    myCP.Description === '' ||
                    myCP.City === '' ||
                    myCP.Zip === '' ||
                    myCP.Country === '' ||
                    myCP.Street === '' ||
                    myCP.Name === '' ||
                    myCP.ContactPersonFirstName === '' ||
                    myCP.ContactPersonLastName === '' ||
                    myCP.ContactPersonSalutation === '' ||
                    myCP.Email === '' ||
                    myCP.Categories.length < 1 ||
                    myCP.Topics.length < 1 ||
                    myCP.Techniques.length < 1
                ) {
                    changes.cpProfileNotCompleted = true;
                    changes.profileNotCompletedWarning = true;
                } else {
                    changes.cpProfileNotCompleted = false;
                }
                if (myCP.BookingTerms === '') {
                    changes.cpBookingTermsNotCompleted = true;
                } else {
                    changes.cpBookingTermsNotCompleted = false;
                }
                this.setState(changes);
            } else {
                this.setState({
                    cpLecturerNotCompleted: false,
                    cpLocationNotCompleted: false,
                    cpProfileNotCompleted: false,
                    profileNotCompletedWarning: false,
                    serverResponse: cpsr,
                });
            }
        });
        ApiAccountingLoadmine(
            {
                ...{
                    Month: moment().subtract(1, 'months').format('YYYY-MM'),
                    ShowVirtual: false,
                },
            },
            (sr1) => {
                if (sr1.OK && sr1.Data && sr1.Data.Accounted) {
                    if (sr1.Data.Accounted.InvoiceState === 'new') {
                        this.setState({ serverResponse: sr1, warningInvoice: true });
                    }
                } else {
                    this.setState({ serverResponse: sr1, warningInvoice: false });
                }
            }
        );
    };

    private searchCourses = () => {
        ApiCourseLoadmine({ ...this.state.searchParams }, (sr) => {
            if (sr.OK && sr.Data) {
                this.setState({
                    listData: sr.Data && sr.Data.Lines ? sr.Data.Lines : [],
                    loading: false,
                    serverResponse: sr,
                    totalCount: sr.Data ? sr.Data.Count : 0,
                });
            } else {
                this.setState({
                    loading: false,
                    serverResponse: sr,
                });
            }
        });
    };

    private onToggleHistory = () => {
        if (this.dpref.current && this.state.noHistory) {
            this.dpref.current.reset();
        } else {
            this.dpref.current.reinit();
        }
        this.setState(
            (prevState: CPAllCoursesState) => {
                return { ...prevState, noHistory: !prevState.noHistory };
            },
            () => {
                window.localStorage.setItem('__FDM_CPCOURSES_NOHISTORY', this.state.noHistory ? 'true' : 'false');
            }
        );
    };

    private courseNew = () => {
        ApiCourseNew((res) => {
            if (res && res.Data) {
                const data = res.Data;
                location.hash = '#/cpcoursedetail/' + data.Course.ID;
            }
        });
    };

    private onClickSorting = (sortField: string, index: number, sortIcon: ISortIcon) => {
        this.changeValue('Sort', sortField, true);
        const mySortIcon: ISortIcon[] = [];
        this.state.sortIcon.map(() => mySortIcon.push(ISortIcon.Sort));
        mySortIcon[index] = sortIcon;
        if (sortIcon === ISortIcon.Sort) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
        if (sortIcon === ISortIcon.SortUp) {
            mySortIcon[index] = ISortIcon.SortDown;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', true, true);
            });
        }
        if (sortIcon === ISortIcon.SortDown) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/views/cpAllCourses/CPAllCourses.tsx